import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import { PrimeNGConfig } from 'primeng/api';
import { GuestMoveService } from '../guest-move.service';
import { GuestMove } from '../guest-move';
import { PropertyService } from '@app/_components/property';
import { ReservationService } from '@app/_components/reservation';
import * as moment from 'moment';
import { first } from 'rxjs/operators';

@Component({
    selector: 'app-guest-move',
    templateUrl: './guest-move.component.html',
    styleUrls: ['./guest-move.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class GuestMoveComponent implements OnInit {
	moveReasons: any;
	properties: any;
	destReservationId: any;
	isSrcReservationId = false;
	isDestReservationId = false;
	srcTitle = "Source Reservation";
	destTitle = "Destination Reservation";
	reservation: any;
	desrReservation: any;
	hksPaidBys: any;
	srcMoveDate: any;
	destMoveDate: any;
	orderReservations: any[] = [];
	orderId: any;

	ruSyncResult: {
		hasData: boolean;
		isError: boolean;
		message: string;
		requestXml: string;
		responseXml: string;
		status: any;
	} = null;
	constructor(
		private reservationService: ReservationService,
		private propertyService: PropertyService,
		private primengConfig: PrimeNGConfig,
		private guestMoveService: GuestMoveService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		console.log('guestMovedata: ',data.guestMove);
		this.formTitle = data.title,
		this.guestMove = data.guestMove;
		this.srcReservationId = data.guestMove?.srcReservationId;
		this.destReservationId = data.guestMove?.destReservationId;
		this.srcMoveDate = data?.guestMove?.srcMoveDate || null;
		this.destMoveDate = data?.guestMove?.destMoveDate || null;
		this.orderId = data?.orderId || data?.guestMove?.orderId;
		this.statuses = guestMoveService.statuses;
		this.moveReasons = guestMoveService.moveReasons;
		this.hksPaidBys = guestMoveService.hksPaidBys;
	}


	@Input() srcReservationId: any;
	@Input() guestMove: GuestMove;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	guestMoveId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'guestMoveId': [],
		'orderId': [],
		'srcReservationId': [{ type: 'required', message: 'Source reservation is required' }],
		'destReservationId': [{ type: 'required', message: 'Destination reservation is required' }],
		'moveReason': [],

		'srcTotalNights': [],
		'srcMoveDate': [],
		'srcRatePN': [],
		'srcHskPaidBy': [],
		'srcHskFee': [],

		'destTotalNights': [],
		'destMoveDate': [],
		'destRatePN': [],
		'destHskPaidBy': [],
		'destHskFee': [],
		'opsNotes': [{ type: 'required', message: 'Options Notes is required' }],
	};

	ngOnInit() {

		// 1. if the srcReservationId is passed as input above, fetch from the reservationController and get the reservation object which will be the srcReservation object
		// 2. use the srcReservationId object to populate the src fields

		this.fetchProperties();
		this.primengConfig.ripple = true;
		this.formBuild();

		// Set orderId in form from dialog data or guestMove
		if (this.orderId) {
			this.form1.patchValue({
				orderId: this.orderId
			});
		}

		// if we were passed the whole guestMove object
		if (this.guestMove) {
			this.guestMoveId = this.guestMove.guestMoveId;
			this.fixDates();
			this.form1.patchValue(this.guestMove);
			// Get orderId from guestMove if not already set
			if (!this.orderId && this.guestMove.orderId) {
				this.orderId = this.guestMove.orderId;
				this.form1.patchValue({
					orderId: this.orderId
				});
			}
		}

		// Fetch order reservations if orderId is available
		// Use orderId from form if component property is not set
		const finalOrderId = this.orderId || this.form1.get('orderId')?.value;
		if (finalOrderId) {
			if (!this.orderId) {
				this.orderId = finalOrderId;
			}
			this.fetchOrderReservations();
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.guestMoveId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	onSyncRu() {
		if (!this.guestMoveId) {
			return;
		}

		this.confirmationService.confirm({
			message: 'Retry RU sync for Guest Move Id# ' + this.guestMoveId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.syncRu();
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'RU sync canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		// Re-entry guard: a request is already in flight. Without this, a quick
		// second click on "Add Guest Move" fires another POST before the first
		// response sets guestMoveId, creating a duplicate GuestMoveVO row.
		if (this.formLoading) {
			return;
		}
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			// Build payload with formatted dates
			const payload = this.buildPayload();

			// Set reservation IDs
			payload.srcReservationId = this.srcReservationId;
			if (payload.srcReservationId == null) {
				this.isSrcReservationId = true;
				return;
			}

			payload.destReservationId = this.destReservationId;
			if (payload.destReservationId == null) {
				this.isDestReservationId = true;
				return;
			}

			// Remove vehicleBookingId if present (for add operation)
			payload?.guestMoveId ? delete payload.guestMoveId : '';

			this.ruSyncResult = null;
			this.formLoading = true;
			this.guestMoveService.add(payload)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestMove = res.data.guestMove;
						// Flip the form into "edit" mode so a second click cannot re-trigger
						// another POST (which would create a duplicate GuestMoveVO and copy
						// the invoice again). Also reset copySrcInvoice so any subsequent
						// PATCH never carries it back to the backend.
						this.guestMoveId = this.guestMove?.guestMoveId;
						this.form1.patchValue({ guestMoveId: this.guestMoveId, copySrcInvoice: false });
						this.handleRuResponseData(res);
						this.doAdd.emit(this.guestMove);
					},
					(err: any) => {
						console.log('guestMove-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		// Re-entry guard: a PATCH is already in flight.
		if (this.formLoading) {
			return;
		}
		console.log('guestMove: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.ruSyncResult = null;
			this.formLoading = true;

			// Build payload with formatted dates
			const payload = this.buildPayload();

			this.guestMoveService.update(payload)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestMove = res.data.guestMove;
						this.handleRuResponseData(res);
						this.doUpdate.emit(this.guestMove);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.guestMoveService.delete(this.guestMove.guestMoveId)
				.subscribe(
					(res: any) => {
						console.log('guestMove-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.guestMove);
					},
					(err: any) => {
						console.log('guestMove-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	private syncRu() {
		try {
			this.ruSyncResult = null;
			this.formLoading = true;
			this.guestMoveService.syncRu(this.guestMoveId)
				.subscribe(
					(res: any) => {
						console.log('guestMove-sync-ru SUCCESS: ' + JSON.stringify(res));
						this.handleRuResponseData(res);
						const severity = this.ruSyncResult?.isError ? 'warn' : 'success';
						this.messageService.add({ severity: severity, summary: severity === 'success' ? 'Success' : 'Warning', detail: res.message });
					},
					(err: any) => {
						console.log('guestMove-sync-ru FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			guestMoveId: [this.guestMoveId],
			orderId: [],
			srcReservationId: [null, Validators.required],
			destReservationId: [null, Validators.required],
			moveReason: [],

			srcTotalNights: [],
			srcMoveDate: [],
			srcRatePN: [],
			srcHskPaidBy: [],
			srcHskFee: [],

			destTotalNights: [],
			destMoveDate: [],
			destRatePN: [],
			destHskPaidBy: [],
			destHskFee: [],
			opsNotes: [null, Validators.required],
			copySrcInvoice: [false],
		});
	}

	fixDates() {
		// Parse dates using timezone-agnostic approach
		if (this.guestMove && this.guestMove.guestMoveDate) {
			this.guestMove.guestMoveDate = this.parseDate(this.guestMove.guestMoveDate);
		}
		if (this.guestMove && (this.guestMove as any).srcMoveDate) {
			(this.guestMove as any).srcMoveDate = this.parseDate((this.guestMove as any).srcMoveDate);
		}
		if (this.guestMove && (this.guestMove as any).destMoveDate) {
			(this.guestMove as any).destMoveDate = this.parseDate((this.guestMove as any).destMoveDate);
		}
		
		// Also update component properties for consistency
		if (this.srcMoveDate) {
			this.srcMoveDate = this.parseDate(this.srcMoveDate);
		}
		if (this.destMoveDate) {
			this.destMoveDate = this.parseDate(this.destMoveDate);
		}
	}

	/**
	 * Parse date string from server to local Date object for display
	 * Handles timezone correctly by treating date strings as timezone-agnostic values
	 */
	private parseDate(value: any): Date | null {
		if (!value) return null;

		// If already a Date, return as-is
		if (value instanceof Date) {
			return value;
		}

		// Accept: yyyy-MM-dd or yyyy-MM-ddTHH:mm:ss
		const s = value.replace('Z', '');
		const [datePart, timePart] = s.split('T');

		const [y, m, d] = datePart.split('-').map(Number);

		let hh = 0, mm = 0, ss = 0;
		if (timePart) {
			const t = timePart.split(':');
			hh = Number(t[0] || 0);
			mm = Number(t[1] || 0);
			ss = Number((t[2] || '0').substring(0, 2));
		}

		// IMPORTANT:
		// This creates a local Date with EXACT same fields
		// No UTC, no offset math
		return new Date(y, m - 1, d, hh, mm, ss);
	}

	/**
	 * Format date value to string for API (timezone-agnostic)
	 * Extracts date and time components directly
	 */
	private formatDate(value: any): string | null {
		if (!value) return null;

		// Already backend string → return as-is
		if (typeof value === 'string') {
			return value.replace('Z', '');
		}

		const d = value as Date;

		const y = d.getFullYear();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		const hh = String(d.getHours()).padStart(2, '0');
		const mm = String(d.getMinutes()).padStart(2, '0');
		const ss = String(d.getSeconds()).padStart(2, '0');

		return `${y}-${m}-${day}T${hh}:${mm}:${ss}`;
	}

	/**
	 * Build payload with formatted dates for API
	 */
	private buildPayload(): any {
		const v = { ...this.form1.value };

		// Format all date-time fields
		v.srcMoveDate = this.formatDate(v.srcMoveDate);
		v.destMoveDate = this.formatDate(v.destMoveDate);

		return v;
	}

	fetchProperties() {
		if (!this.properties || this.properties === undefined || this.properties.length < 1) {
			try {
				this.propertyService.findAllSummary()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.properties = res.data.properties;
							return this.properties;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.properties);
		}
	}

	srcReservationInfoItem(event: any) {
		console.log("Source Reservation : " + JSON.stringify(event));
		this.isSrcReservationId = false;
		this.srcReservationId = event.reservationId;
		this.fetchSrcReservationById(this.srcReservationId);
		/*this.form1.patchValue({
			srcTotalNights: event.numNights,
		});*/
	}

	onSourceReservationChange(event: any) {
		console.log("Source Reservation Changed: " + JSON.stringify(event));
		this.isSrcReservationId = false;
		const reservationId = event.value;
		if (reservationId) {
			this.srcReservationId = reservationId;
			// Populate orderId in the form if we have it
			if (this.orderId) {
				this.form1.patchValue({
					orderId: this.orderId
				});
			}
			this.fetchSrcReservationById(reservationId);
		}
	}

	fetchSrcReservationById(reservationId: any) {
		try {
			this.reservationService.findById(reservationId)
				.subscribe(
					res => {
						console.log('findById reservation : ' + JSON.stringify(res));
						this.reservation = res.data.reservation;
						const orderIdFromReservation = this.reservation.order?.orderId;
						
						// Update component orderId property
						if (orderIdFromReservation) {
							this.orderId = orderIdFromReservation;
						}
						
						this.form1.patchValue({
							orderId: orderIdFromReservation,
							srcTotalNights: this.reservation.numNights,
							srcRatePN: this.reservation.nightlyRate,
							srcHskFee: this.reservation.hskFee,
						});

						// Fetch order reservations if orderId is available and not already fetched
						if (orderIdFromReservation && (!this.orderReservations || this.orderReservations.length === 0)) {
							this.fetchOrderReservations();
						}
						
						return this.reservation;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	destReservationInfoItem(event: any) {
		console.log("Destination Reservation : " + JSON.stringify(event));
		this.isDestReservationId = false;
		this.destReservationId = event.reservationId;
		this.fetchDestReservationById(this.destReservationId);
		/*this.form1.patchValue({
			destTotalNights: event.numNights,
		});*/
	}

	onDestinationReservationChange(event: any) {
		console.log("Destination Reservation Changed: " + JSON.stringify(event));
		this.isDestReservationId = false;
		const reservationId = event.value;
		if (reservationId) {
			this.destReservationId = reservationId;
			// Populate orderId in the form if we have it
			if (this.orderId) {
				this.form1.patchValue({
					orderId: this.orderId
				});
			}
			this.fetchDestReservationById(reservationId);
		}
	}

	private handleRuResponseData(res: any) {
		if (!res?.data) return;

		const ruStatus = res.data.ruStatus;
		const requestXml = res.data.ruRequestXml;
		const responseXml = res.data.ruResponseXml;

		if (!ruStatus && !requestXml && !responseXml) return;

		const isError = ruStatus?.errorCollection?.length > 0;
		const alerts = ruStatus?.alertCollection || [];
		const lastAlert = alerts.length > 0 ? alerts[alerts.length - 1] : null;
		const message = lastAlert?.errorMessage || (isError ? 'RU sync completed with errors' : 'RU sync completed successfully');

		this.ruSyncResult = {
			hasData: true,
			isError: isError,
			message: message,
			requestXml: requestXml || '',
			responseXml: responseXml || '',
			status: ruStatus
		};
	}

	fetchDestReservationById(reservationId: any) {
		try {
			this.reservationService.findById(reservationId)
				.subscribe(
					res => {
						console.log('findById reservation : ' + JSON.stringify(res));
						this.desrReservation = res.data.reservation;
						const orderIdFromReservation = this.desrReservation.order?.orderId;
						
						// Update component orderId property
						if (orderIdFromReservation) {
							this.orderId = orderIdFromReservation;
						}
						
						this.form1.patchValue({
							orderId: orderIdFromReservation,
							destTotalNights: this.desrReservation.numNights,
							destRatePN: this.desrReservation.nightlyRate,
							destHskFee: this.desrReservation.hskFee,
						});

						// Fetch order reservations if orderId is available and not already fetched
						if (orderIdFromReservation && (!this.orderReservations || this.orderReservations.length === 0)) {
							this.fetchOrderReservations();
						}
						
						return this.desrReservation;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onOrderIdChange() {
		const formOrderId = this.form1.get('orderId')?.value;
		if (formOrderId && formOrderId !== this.orderId) {
			this.orderId = formOrderId;
			// Clear source and destination reservations when orderId changes
			this.form1.patchValue({
				srcReservationId: null,
				destReservationId: null
			});
			this.srcReservationId = null;
			this.destReservationId = null;
			this.orderReservations = [];
			// Fetch reservations for the new orderId
			this.fetchOrderReservations();
		}
	}

	fetchOrderReservations() {
		if (!this.orderId) {
			this.orderReservations = [];
			return;
		}

		try {
			this.reservationService.findByOrderId(this.orderId)
				.pipe(first())
				.subscribe(
					res => {
						console.log('findByOrderId reservations: ' + JSON.stringify(res));
						const reservations = res.data.reservations;
						if (reservations && reservations.length > 0) {
							// Format reservations for dropdown display - ReservationId : PropertyCode : Guest LastName, FirstName
							this.orderReservations = reservations.map((reservation: any) => {
								const reservationId = reservation.reservationId?.toString() || '';
								const propertyCode = reservation.shortTermRental?.propertyCode || '';
								const lastName = reservation.guestProfile?.lastName || '';
								const firstName = reservation.guestProfile?.firstName || '';
								
								// Format guest name: LastName, FirstName
								let guestName = '';
								if (lastName && firstName) {
									guestName = `${lastName}, ${firstName}`;
								} else if (lastName) {
									guestName = lastName;
								} else if (firstName) {
									guestName = firstName;
								}
								
								const displayLabel = `${reservationId} : ${propertyCode} : ${guestName}`.trim();
								
								return {
									...reservation,
									displayLabel: displayLabel
								};
							});
							console.log('Order reservations formatted: ' + JSON.stringify(this.orderReservations));
						} else {
							this.orderReservations = [];
						}
					},
					err => {
						console.log('Error fetching reservations by orderId: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.orderReservations = [];
					},
					() => { });
		} catch (error) {
			console.log('Error in fetchOrderReservations: ' + JSON.stringify(error));
			this.alertService.error(error);
			this.orderReservations = [];
		}
	}
}
